<template>
  <div id="cesiumContainer" ref="viewer">
    <!--    组合拼接头部，同时最多四到五个组件组合-->
    <div
      id="viewer-panel"
      class="sm-panel"
    >
      <div class="sm-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { URL_CONFIG } from '../../common/js/config';

export default {
  name: 'sm-viewer',
  props: {
    sceneUrl: {
      //场景接口
      type: String
    },
    s3mScps: {
      //s3m图层接口
      type: Array
    },
    tilesUrl: String,
    collapsed: {
      //是否折叠
      type: Boolean
    },
    center: Object,
  },
  data() {
    return {
      show: true,
      sharedState: window.store.state
    };
  },

  computed: {
    iconfont: function() {
      let ifontClass;
      let type = this.sharedState.componentTypes[0];
      switch (type) {
        case 'clip':
          ifontClass = 'iconfont iconcaijian';
          break;
        case 'terrain':
          ifontClass = 'iconfont icondixing';
          break;
        case 'analysis':
          ifontClass = 'iconfont iconsanweifenxi';
          break;
        default:
          null;
          break;
      }
      return ifontClass;
    },
    componentName: function() {
      return this.sharedState.componentNames;
    },
    componentShow: function() {
      return this.sharedState.componentShows;
    }
  },

  methods: {
    toggleVisibility() {
      //控制组件界面显隐
      this.show = !this.show;
    },
    //点击切换组件功能
    span(i) {
      // 验证是否为点击事件，是则继续执行click事件，否则不执行
      let isClick = document
        .getElementById('viewer-panel')
        .getAttribute('data-flag');
      if (isClick !== 'true') {
        return false;
      }
      window.store.clickComponentShow(i);
    },

    init() {
      //初始化viewer
      if (window.viewer) {
        window.viewer.destroy();
        window.viewer = null;
        // return;
      }
      const { Cesium } = window;

      var viewer = new Cesium.Viewer('cesiumContainer', {
        infoBox: false,
        selectionIndicator: false,
        // 添加STK World Terrain地形服务
        // terrainProvider: new Cesium.CesiumTerrainProvider({
        //   url: URL_CONFIG.STK,
        //   requestWaterMask: true,
        //   requestVertexNormals: true,
        //   isSct: false
        // })
      });

      viewer.imageryLayers.addImageryProvider(
        new window.Cesium.TiandituImageryProvider({
          credit: new window.Cesium.Credit(
            '天地图全球影像服务     数据来源：国家地理信息公共服务平台 & 四川省测绘地理信息局'
          ),
          token: URL_CONFIG.TOKEN_TIANDITU
        })
      );
      var imageryLayers = viewer.imageryLayers;
      //初始化天地图全球中文注记服务，并添加至影像图层
      var labelImagery = new window.Cesium.TiandituImageryProvider({
        mapStyle: window.Cesium.TiandituMapsStyle.CIA_C, //天地图全球中文注记服务（经纬度投影）
        token: URL_CONFIG.TOKEN_TIANDITU
      });
      imageryLayers.addImageryProvider(labelImagery);
      //添加新的天地图服务
      imageryLayers.addImageryProvider(
        new window.Cesium.TiandituImageryProvider({
          mapStyle: window.Cesium.TiandituMapsStyle['IMG_C'],
          token: URL_CONFIG.TOKEN_TIANDITU
        }),
        1
      );
      var options = {
        url: 'https://t{s}.tianditu.gov.cn/DataServer?T=elv_c&tk={k}',
        token: URL_CONFIG.TOKEN_TIANDITU,
        subdomains: ['0', '1', '2', '3', '4', '5', '6', '7']
      };
      var provider = new window.Cesium.TiandituTerrainProvider(options);
      const subdomains = ['0', '1', '2', '3', '4', '5', '6', '7'];
      provider._urls = subdomains.map(sub => {
        return `https://t${sub}.tianditu.gov.cn/mapservice/swdx?T=elv_c&tk=${URL_CONFIG.TOKEN_TIANDITU}`;
      });
      viewer.terrainProvider = provider;

      //三维地名
      new window.Cesium.TiandituAnnotationProvider({
        viewer: viewer,
        url: 'http://zhuji.tianditu.cn/swdm/wtfs'
      });

      // // 叠加地形服务
      // var token = URL_CONFIG.TOKEN_TIANDITU;
      // // 服务域名
      // var tdtUrl = 'https://t{s}.tianditu.gov.cn/';
      // // 服务负载子域
      // var subdomains = ['0', '1', '2', '3', '4', '5', '6', '7'];

      // var terrainUrls = new Array();

      // for (var i = 0; i < subdomains.length; i++) {
      //   var url =
      //     tdtUrl.replace('{s}', subdomains[i]) + 'mapservice/swdx?tk=' + token;
      //   terrainUrls.push(url);
      // }

      // var provider = new Cesium.GeoTerrainProvider({
      //   urls: terrainUrls
      // });

      // viewer.terrainProvider = provider;

      // // 将三维球定位到中国
      // viewer.camera.flyTo({
      //   destination: Cesium.Cartesian3.fromDegrees(103.84, 31.15, 17850000),
      //   orientation: {
      //     heading: Cesium.Math.toRadians(348.4202942851978),
      //     pitch: Cesium.Math.toRadians(-89.74026687972041),
      //     roll: Cesium.Math.toRadians(0)
      //   },
      //   complete: function callback() {
      //     // 定位完成之后的回调函数
      //   }
      // });

      // 叠加三维地名服务
      // var wtfs = new Cesium.GeoWTFS({
      //   viewer,
      //   subdomains: subdomains,
      //   metadata: {
      //     boundBox: {
      //       minX: -180,
      //       minY: -90,
      //       maxX: 180,
      //       maxY: 90
      //     },
      //     minLevel: 1,
      //     maxLevel: 20
      //   },
      //   aotuCollide: true, //是否开启避让
      //   collisionPadding: [5, 10, 8, 5], //开启避让时，标注碰撞增加内边距，上、右、下、左
      //   serverFirstStyle: true, //服务端样式优先
      //   labelGraphics: {
      //     font: '28px sans-serif',
      //     fontSize: 28,
      //     fillColor: Cesium.Color.WHITE,
      //     scale: 0.5,
      //     outlineColor: Cesium.Color.BLACK,
      //     outlineWidth: 5,
      //     style: Cesium.LabelStyle.FILL_AND_OUTLINE,
      //     showBackground: false,
      //     backgroundColor: Cesium.Color.RED,
      //     backgroundPadding: new Cesium.Cartesian2(10, 10),
      //     horizontalOrigin: Cesium.HorizontalOrigin.MIDDLE,
      //     verticalOrigin: Cesium.VerticalOrigin.TOP,
      //     eyeOffset: Cesium.Cartesian3.ZERO,
      //     pixelOffset: new Cesium.Cartesian2(0, 8)
      //   },
      //   billboardGraphics: {
      //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      //     verticalOrigin: Cesium.VerticalOrigin.CENTER,
      //     eyeOffset: Cesium.Cartesian3.ZERO,
      //     pixelOffset: Cesium.Cartesian2.ZERO,
      //     alignedAxis: Cesium.Cartesian3.ZERO,
      //     color: Cesium.Color.WHITE,
      //     rotation: 0,
      //     scale: 1,
      //     width: 18,
      //     height: 18
      //   }
      // });

      // //三维地名服务，使用wtfs服务
      // wtfs.getTileUrl = function() {
      //   return tdtUrl + 'mapservice/GetTiles?lxys={z},{x},{y}&tk=' + token;
      // };

      // wtfs.initTDT([
      //   {
      //     x: 6,
      //     y: 1,
      //     level: 2,
      //     boundBox: { minX: 90, minY: 0, maxX: 135, maxY: 45 }
      //   },
      //   {
      //     x: 7,
      //     y: 1,
      //     level: 2,
      //     boundBox: { minX: 135, minY: 0, maxX: 180, maxY: 45 }
      //   },
      //   {
      //     x: 6,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: 90, minY: 45, maxX: 135, maxY: 90 }
      //   },
      //   {
      //     x: 7,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: 135, minY: 45, maxX: 180, maxY: 90 }
      //   },
      //   {
      //     x: 5,
      //     y: 1,
      //     level: 2,
      //     boundBox: { minX: 45, minY: 0, maxX: 90, maxY: 45 }
      //   },
      //   {
      //     x: 4,
      //     y: 1,
      //     level: 2,
      //     boundBox: { minX: 0, minY: 0, maxX: 45, maxY: 45 }
      //   },
      //   {
      //     x: 5,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: 45, minY: 45, maxX: 90, maxY: 90 }
      //   },
      //   {
      //     x: 4,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: 0, minY: 45, maxX: 45, maxY: 90 }
      //   },
      //   {
      //     x: 6,
      //     y: 2,
      //     level: 2,
      //     boundBox: { minX: 90, minY: -45, maxX: 135, maxY: 0 }
      //   },
      //   {
      //     x: 6,
      //     y: 3,
      //     level: 2,
      //     boundBox: { minX: 90, minY: -90, maxX: 135, maxY: -45 }
      //   },
      //   {
      //     x: 7,
      //     y: 2,
      //     level: 2,
      //     boundBox: { minX: 135, minY: -45, maxX: 180, maxY: 0 }
      //   },
      //   {
      //     x: 5,
      //     y: 2,
      //     level: 2,
      //     boundBox: { minX: 45, minY: -45, maxX: 90, maxY: 0 }
      //   },
      //   {
      //     x: 4,
      //     y: 2,
      //     level: 2,
      //     boundBox: { minX: 0, minY: -45, maxX: 45, maxY: 0 }
      //   },
      //   {
      //     x: 3,
      //     y: 1,
      //     level: 2,
      //     boundBox: { minX: -45, minY: 0, maxX: 0, maxY: 45 }
      //   },
      //   {
      //     x: 3,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: -45, minY: 45, maxX: 0, maxY: 90 }
      //   },
      //   {
      //     x: 2,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: -90, minY: 45, maxX: -45, maxY: 90 }
      //   },
      //   {
      //     x: 0,
      //     y: 1,
      //     level: 2,
      //     boundBox: { minX: -180, minY: 0, maxX: -135, maxY: 45 }
      //   },
      //   {
      //     x: 1,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: -135, minY: 45, maxX: -90, maxY: 90 }
      //   },
      //   {
      //     x: 0,
      //     y: 0,
      //     level: 2,
      //     boundBox: { minX: -180, minY: 45, maxX: -135, maxY: 90 }
      //   }
      // ]);

      if (this.$props.tilesUrl) {
        var tilesetModel = new Cesium.Cesium3DTileset({
          url: `${process.env.VUE_APP_URL}/3d/3dtiles/tileset.json`
        });
        viewer.scene.primitives.add(tilesetModel);
        tilesetModel.readyPromise.then(function() {
          console.log('tilesetModel loaded');
          var boundingSphere = tilesetModel.boundingSphere;
          viewer.camera.viewBoundingSphere(
            boundingSphere,
            new Cesium.HeadingPitchRange(0.0, -0.5, boundingSphere.radius)
          );
        });
      }

      // const update3dtilesMaxtrix = params => {
      //   //旋转
      //   let mx = Cesium.Matrix3.fromRotationX(Cesium.Math.toRadians(params.rx));
      //   let my = Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(params.ry));
      //   let mz = Cesium.Matrix3.fromRotationZ(Cesium.Math.toRadians(params.rz));
      //   let rotationX = Cesium.Matrix4.fromRotationTranslation(mx);
      //   let rotationY = Cesium.Matrix4.fromRotationTranslation(my);
      //   let rotationZ = Cesium.Matrix4.fromRotationTranslation(mz);
      //   //平移
      //   let position = Cesium.Cartesian3.fromDegrees(
      //     params.tx,
      //     params.ty,
      //     params.tz
      //   );
      //   let m = Cesium.Transforms.eastNorthUpToFixedFrame(position);

      //   let scale = Cesium.Matrix4.fromUniformScale(0.85);
      //   // //缩放
      //   Cesium.Matrix4.multiply(m, scale, m);
      //   //旋转、平移矩阵相乘
      //   Cesium.Matrix4.multiply(m, rotationX, m);
      //   Cesium.Matrix4.multiply(m, rotationY, m);
      //   Cesium.Matrix4.multiply(m, rotationZ, m);
      //   //赋值给tileset
      //   return m;
      // };
      // const params = {
      //   tx: 116, //模型中心X轴坐标（经度，单位：十进制度）
      //   ty: 40, //模型中心Y轴坐标（纬度，单位：十进制度）
      //   tz: 2800, //模型中心Z轴坐标（高程，单位：米）
      //   rx: 0, //X轴（经度）方向旋转角度（单位：度）
      //   ry: 0, //Y轴（纬度）方向旋转角度（单位：度）
      //   rz: -1 //Z轴（高程）方向旋转角度（单位：度）
      // };

      let scene = viewer.scene;
      viewer.scene.debugShowFramesPerSecond = false;
      window.viewer = viewer;
      window.scene = scene;
      let widget = viewer.cesiumWidget;

      //打开场景
      let promiseArray = [];
      try {
        if (this.$props.sceneUrl) {
          console.log('sceneUrl', this.$props.sceneUrl);
          promiseArray.push(scene.open(this.sceneUrl));
        } else if (this.$props.s3mScps) {
          //加载scps
          let scps = this.$props.s3mScps;
          scps.forEach(element => {
            promiseArray.push(
              scene.addS3MTilesLayerByScp(element.url, element.options)
            );
          });
        }
        window.Cesium.when.all(
          promiseArray,
          function(layers) {
            window.layers = scene.layers | layers;
            // setTimeout(() => {
            //   document.querySelector("#loadingbar").remove(); //清除加载动画
            // }, 2000);
          },
          function(e) {
            if (widget._showRenderLoopErrors) {
              let title =
                '加载SCP失败，请检查网络连接状态或者url地址是否正确？';
              widget.showErrorPanel(title, undefined, e);
            }
          }
        );
      } catch (e) {
        if (widget._showRenderLoopErrors) {
          let title = '渲染时发生错误，已停止渲染。';
          widget.showErrorPanel(title, undefined, e);
        }
      }
      setTimeout(() => {
        if (!this.$props.tilesUrl) {
          viewer.camera.setView({
            destination: window.Cesium.Cartesian3.fromDegrees(
              this.center?.lon || 116,
              this.center?.lat || 40,
              this.center ? 10000 : 1000000.0,
            )
          });
        }
        this.initEvent();
        window.store.setisInitViewer(true); //初始化viewer标志
        window.common.initHandler('Polygon'); //初始化全局常用的画面的drawhandler
      }, 1000);
    },
    initEvent() {
      const { Cesium, viewer, scene } = window;
      var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);

      handler.setInputAction(async e => {
        const { position } = e;
        const pick = viewer.scene.pick(position);
        if (Cesium.defined(pick) && pick?.id?.id) {
          console.log('picked!' + pick.id.id);
          this.$emit('click', pick.id.id);
          return;
        }
        //获取鼠标屏幕坐标,并将其转化成笛卡尔坐标
        var last = await scene.pickPosition(position);
        // 将鼠标当前点坐标转化成经纬度
        var cartographic = Cesium.Cartographic.fromCartesian(last);
        var lon = Cesium.Math.toDegrees(cartographic.longitude).toFixed(6);
        var lat = Cesium.Math.toDegrees(cartographic.latitude).toFixed(6);
        var height = cartographic.height;
        this.$emit('clickPos', { lon, lat, height });
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }
  },

  mounted() {
    this.init();
  },
  // 跳转路由刷新页面
  beforeMount() {
    if (window.viewer) {
      window.location.reload();
    }
  }
};
</script>
<style lang="less" scoped>
#cesiumContainer {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;

  #viewer-panel {
    top: 55px;
    right: 330px;
  }

  .cesium-viewer-navigationContainer {
    top: 48px;
  }
}
</style>
<style lang="less">
#cesiumContainer {
  .cesium-viewer-navigationContainer {
    top: 48px;
  }
}
</style>
